import React from 'react';
import styled from 'styled-components';
import colors from '../theme/colors';
import NameAvatar from './NameAvatar';
import GivelifyBottomSheet from '../Donee/components/common/Modal/GivelifyBottomSheet';
import { GivelifyLogo, MailIcon } from '../icons';
import { Text } from '../Donee/components/common/Text/Text';
import { GivelifyButton } from '../Donee/components/common/Button/GivelifyButton';
import { FacebookButton } from '../FacebookButton';
import { useLastLogin } from './LastLoginProvider';

const StyledDiv = styled.div`
  .logo-wrapper {
    text-align: center;
    margin-bottom: 16px;
    .logo {
      width: 85px;
    }
  }
  .user-wrapper {
    padding: 24px;
    border-radius: 30px;
    text-align: center;
    border: 1px solid ${colors.utilitySeparatorColor};
    background-color: ${colors.utilityBackgroundLightColor};
    .initial-avatar {
      margin-bottom: 8px;
    }
    .donor-name {
      margin-bottom: 8px;
    }
    .donor-email-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      .donor-email {
        margin-left: 4px;
      }
    }
    .login-with-password {
      margin-top: 24px;
    }
  }
  .login-button {
    padding: 16px;
    margin-top: 16px;
    text-align: center;
    cursor: pointer;
  }
`;

const LoginBottomSheet: React.FC = () => {
  const {
    show,
    type,
    donor,
    forceHide,
    donorName,
    donorEmail,
    donorContext,
    handleCancel,
    handleLogin,
    handleLoginWithPassword,
    handleFacebookClose
  } = useLastLogin();

  if (
    forceHide ||
    donor ||
    !show ||
    donorContext.donor.type === 'REQUEST_START'
  ) {
    return null;
  }

  return (
    <GivelifyBottomSheet onClosedCallback={handleCancel}>
      <StyledDiv>
        <div className="logo-wrapper">
          <GivelifyLogo className="logo" />
        </div>
        <div className="user-wrapper">
          {donorName && (
            <NameAvatar
              name={donorName}
              className="initial-avatar"
            />
          )}
          {donorName && (
            <Text
              weight="extraBold"
              className="donor-name"
            >
              Welcome back,
              <br />
              {donorName}!
            </Text>
          )}
          {donorEmail && (
            <div className="donor-email-wrapper">
              <MailIcon />
              <Text
                variant="xSmall"
                className="donor-email"
                color="primarySecondaryContent"
              >
                {donorEmail}
              </Text>
            </div>
          )}
          {type === 'facebook' ? (
            <FacebookButton onSuccess={handleFacebookClose} />
          ) : (
            <GivelifyButton
              onClick={handleLoginWithPassword}
              className="login-with-password"
            >
              Sign in with Password
            </GivelifyButton>
          )}
        </div>
        <Text
          variant="small"
          className="login-button"
          color="primarySecondaryContent"
          onClick={handleLogin}
        >
          Sign in with Another Account
        </Text>
      </StyledDiv>
    </GivelifyBottomSheet>
  );
};

export default LoginBottomSheet;
